export const setDocumentTitle = function (title) {
    document.title = title
    const ua = navigator.userAgent
    // eslint-disable-next-line
    const regex = /\bMicroMessenger\/([\d\.]+)/
    if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
      const i = document.createElement('iframe')
      i.src = '/favicon.ico'
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(function () {
          i.remove()
        }, 9)
      }
      document.body.appendChild(i)
    }
  }

// 移除dom
export function removeElement (id = '', timeout = 300) {
  let timer = null
  let children = null
  if (!id) {
    return
  }
  children = document.getElementById(id)
  if (!children) {
    return
  }
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    children = document.getElementById(id)
    if (!children) {
      return
    }
    document.body.removeChild(children)
  }, timeout)
}

// 下载文件, 同源文件或者base64
export function downloadData (res, fileName) {
  if(!res || !res.data) {
    return
  }
  let disposition = res.headers['content-disposition']
  if(disposition) {
    let fileNameDispostion = disposition.split(';').find(item => item.indexOf('filename') >-1)
    if(fileNameDispostion)
      fileName = decodeURIComponent( fileNameDispostion.replace('filename=', ''))
  }

  let data = res.data
  let url = window.URL.createObjectURL(data)
  let aLink = document.createElement("a")
  aLink.style.display = "none"
  aLink.href = url
  aLink.setAttribute("download", fileName)
  document.body.appendChild(aLink)
  aLink.click()
  document.body.removeChild(aLink) //下载完成移除元素
  window.URL.revokeObjectURL(url); //释放掉blob对象
}

export function downloadFile (url) {
  if(!url) {
    return
  }

  let aLink = document.createElement("a")
  aLink.style.display = "none"
  aLink.href = url
  document.body.appendChild(aLink)
  aLink.click()
  document.body.removeChild(aLink) //下载完成移除元素
}

// 复制
export function copyText(value) {
  let oInput = document.createElement('input')
  oInput.value = value;
  document.body.appendChild(oInput)
  try {
      oInput.select() // 选择对象
      document.execCommand("Copy") // 执行浏览器复制命令
      return true
  } catch {
      this.$message.error('复制失败')
  }
  finally {
      oInput.remove()
  }
  return false
}

// 比对版本：1 v1大；0 一样大；2 v2大
export function compareVersion(v1, v2) {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i])
    const num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}

/**
 *获取id
 */
export function getNewGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
  });
}

export function formatCurrency(number) {
  const reg = /\B(?=(?:\d{3})+(?!\d))/g
    const reg2 = /^(\d+)\.(\d+)$/;
    const strNumber = number + '';
    const int = strNumber.replace(reg2, '$1') || ''
    const float = reg2.test(strNumber) ? strNumber.replace(reg2, '$2') : ''
    return int.replace(reg, function (match, ...args) {
        return match + ','
    }) + (float.padStart(float.length > 0 ? float.length + 1 : 0, '.'))
}


/**
 * 获取传输的精度金额
 */
 export function getTransferAmount(amount, decimals = 18) {
  return amount * Math.pow(10, decimals);
}


/**
 * 获取传输的精度金额
 */
export function getRealAmount(balance, decimals = 18) {
  return Number(balance) / Math.pow(10, decimals);
}
